import React from "react";
import { Button } from "@/components/ui/button";
import { Wand2 } from "lucide-react";
import { toast } from "sonner";

/**
 * Il nome del cantiere ricavato dall'indirizzo appena scelto.
 *
 * Quasi sempre il cantiere si chiama come il posto dove si lavora, e riscriverlo
 * a mano sotto al campo dell'indirizzo e' lavoro doppio. Qui si tiene solo il
 * testo - comune, via e civico - buttando via CAP, provincia e nazione che
 * Google aggiunge all'indirizzo completo. Il campo resta scrivibile: chi
 * preferisce un nome suo lo scrive come ha sempre fatto.
 */
export function nomeDaIndirizzo(indirizzo, comuneNoto) {
  const pezzi = String(indirizzo || "")
    .split(",")
    .map((p) => p.trim())
    .filter((p) => p && !/^(italia|italy)$/i.test(p));
  if (!pezzi.length) return "";

  // La parte con il CAP porta anche il comune: "20098 San Giuliano Milanese MI".
  let comune = (comuneNoto || "").trim();
  const iCap = pezzi.findIndex((p) => /^\d{5}\b/.test(p));
  if (iCap >= 0 && !comune) {
    comune = pezzi[iCap]
      .replace(/^\d{5}\s*/, "")
      .replace(/\s+[A-Z]{2}$/, "")
      .trim();
  }

  // Quello che viene prima del CAP e' la strada; l'ultimo pezzo, se e' un
  // numero, e' il civico. Senza CAP si tiene il primo pezzo e basta.
  const prima = iCap >= 0 ? pezzi.slice(0, iCap) : pezzi.slice(0, 1);
  let strada = prima.join(" ").replace(/\s+/g, " ").trim();
  if (!strada && iCap < 0) strada = pezzi[0] || "";

  const parti = [comune, strada].filter(Boolean);
  return parti.join(" - ");
}

export default function NomeDaIndirizzo({ scheda, onNome, className = "" }) {
  const genera = () => {
    const nome = nomeDaIndirizzo(scheda?.address, scheda?.comune);
    if (!nome) {
      toast.error("Prima scegli l'indirizzo del cantiere");
      return;
    }
    onNome(nome);
  };
  return (
    <Button type="button" variant="outline" onClick={genera}
            className={`h-10 px-3 flex-shrink-0 ${className}`}
            title="Scrive il nome usando comune, via e civico dell'indirizzo"
            data-testid="nome-da-indirizzo">
      <Wand2 className="w-4 h-4 sm:mr-2" />
      <span className="hidden sm:inline">Genera da indirizzo</span>
    </Button>
  );
}
